"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var settings_1 = require("./settings");
var of_1 = require("rxjs/observable/of");
require("./sis-tooltip.component.scss");
var TooltipComponent = /** @class */ (function () {
    function TooltipComponent(currentLanguageProvider) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.tooltipWidth = 'auto';
        this.multilingualTooltipTitle$ = of_1.of('');
        this.multilingualTooltipText$ = of_1.of('');
    }
    TooltipComponent.prototype.ngOnInit = function () {
        this.identifyCurrentMessage();
    };
    TooltipComponent.prototype.getCurrentMessage = function (currentLanguageId, text) {
        if (text && currentLanguageId) {
            if (text instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                return text.getValue(currentLanguageId);
            }
            else {
                return JSON.parse(text)._values
                    ? JSON.parse(text)._values.find(function (item) {
                        return item[0] === currentLanguageId;
                    })[1]
                    : text;
            }
        }
        return '';
    };
    TooltipComponent.prototype.identifyCurrentMessage = function () {
        var _this = this;
        this.multilingualTooltipText$ = this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.map(function (language) {
            return _this.getCurrentMessage(language.getId(), _this.tooltipText);
        }));
        this.multilingualTooltipTitle$ = this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.map(function (language) {
            return _this.getCurrentMessage(language.getId(), _this.tooltipTitle);
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "tooltipText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "tooltipTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "tooltipWidth", void 0);
    TooltipComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-tooltip',
            template: require('./sis-tooltip.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Tooltip',
            nameKey: 'de.controls.tooltip.title',
            cellCount: 1,
            settings: {
                main: settings_1.TooltipSettingsComponent,
            },
            template: "",
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], TooltipComponent);
    return TooltipComponent;
}());
exports.TooltipComponent = TooltipComponent;
//# sourceMappingURL=sis-tooltip.component.js.map